import etZoneDataConfig from '@/api/config/etZoneDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useEtZoneById(interfaceId: any, id: any) {
  return useQuery([[queryKeys.etZone], id], async () => {
    if (!interfaceId || !id) return null
    const { data } = await etZoneDataConfig.getById(
      interfaceId.toString(),
      id.toString(),
    )
    if (!data) return null

    return data
  })
}

export default useEtZoneById
